import { authAPI } from "../auth/auth";

export const adminApi = {
    async isAdmin() {
        let resp = await fetch(`/api/admin/is-admin`, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
            },
        }).catch(e => console.log(e))

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.isAdmin(
                );
            }
            return {
                ok: false,
                err: "unauthorized",
            };
        }

        let error = null
        let body = await resp.json().catch(e => error = e)
        if(!body || error)
        {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }

        if(body.ok) {
            return {
                ok: true,
                admin: body.admin
            }
        }

        if(body.err) {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }
    },
    async loginAsUser(email) {
        if(!email) return {
            ok: false,
            err: "invalid email"
        }

        let body = {email: email}

        let error = null
        let resp = await fetch(`/api/admin/login-as-user`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-type": "application/json",
            },
        }).catch(e => error = e)

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.loginAsUser(email);
            }
            return {
                ok: false,
                err: "unauthorized",
            };
        }

        let data = await resp.json().catch(e => error = e)
        if(!data || error)
        {
            return {
                ok: false,
                err: "something_went_wrong"
            }
        }

        if(data.ok) {
            return {
                ok: true,
                user: body.user
            }
        }

        if(data.err) {
            return {
                ok: false,
                err: data.err
            }
        }
    },
    async getAllUsers() {
        let error = null;
        const resp = await fetch("/api/admin/users")
            .catch((e) => (error = e));
        
        const data = await resp.json().catch((e) => (error = e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.getAllUsers();
            }
            return {
                ok: false,
                err: "unauthorized",
            };
        }

        if (!data || error) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if(data.ok) {
            return {
                ok: true,
                users: data.users
            }
        }

        if(data.err) {
            return {
                ok: false,
                err: data.err
            }
        }
    },
    async updateDiscount(id, discount) {
        let error = null;
        console.log("fetching")
        const resp = await fetch("/api/admin/update-user-discount", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                id,
                "b2b-discount-in-percent": discount.b2b,
                "b2c-discount-in-percent": discount.b2c,
                "c2c-discount-in-percent": discount.c2c,
                "documents-discount-in-percent": discount.documents
            })
        })
            .catch((e) => (error = e));
        
        const data = await resp.json().catch((e) => (error = e));

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.updateDiscount();
            }
            return {
                ok: false,
                err: "unauthorized",
            };
        }

        if (!data || error) {
            return {
                ok: false,
                err: "something_went_wrong",
            };
        }

        if(data.ok) {
            return {
                ok: true,
            }
        }

        if(data.err) {
            return {
                ok: false,
                err: data.err
            }
        }
    }
}